import { createFileRoute } from "@tanstack/react-router";

import { WhatsAppConnectPage } from "../components/whatsapp/WhatsAppConnectPage";

export const Route = createFileRoute("/settings/whatsapp-connect")({
  component: WhatsAppConnectPage,
});
